import { reactive } from 'vue';
import { jwtDecode } from 'jwt-decode';
import { request } from './api';

export const globalState = reactive({
  userInfo: {},
  user: {
    id: '',
    name: '',
    email: '',
    phone: '',
    country_code: '',
    avatar: '',
    email_verified: true,
    token: '',
  },
  usage: {
    isPro: false,
    used: 0,
    remaining: 5,
    total: 5,
  },
  job: null,
});

export async function refreshUsage() {
  getUser();
  if (!globalState.user.id) return;
  try {
    const data = await request(`/billing/usage`);
    globalState.usage.used = data.used;
    globalState.usage.total = data.total;
    globalState.usage.remaining = data.total - data.used;
    globalState.usage.isPro = data.total > 20;
  } catch (e) {
    globalState.usage.used = 0;
    globalState.usage.total = 0;
    throw e;
  }
}

export async function refreshUserProfile() {
  if (!getToken()) return;
  const user = await request(`/user/info`);
  globalState.userInfo.email_verified = user.email_verified;
  globalState.userInfo.phone_verified = user.phone_verified;
  globalState.userInfo.verified = user.phone_verified || user.email_verified;
  globalState.userInfo.avatar = user.avatar;
  globalState.userInfo.phone = user.phone;
  globalState.userInfo.country_code = user.country_code;
  globalState.userInfo.name = user.name;
}

export async function getUserAsync() {
  try {
    if (globalState.job) {
      await globalState.job;
    } else {
      globalState.job = refreshUserProfile().then(() => {
        globalState.job = null;
      });
      await globalState.job;
    }
  } catch (e) {
    console.error(e);
  }
  return getUser();
}

let memoryToken = '';
export function setToken(token = '', { memoryOnly = false } = {}) {
  memoryToken = token;
  if (!memoryOnly) {
    localStorage.token = token;
  }
  getUser();
}

export function getToken() {
  return memoryToken || localStorage.token;
}

export async function updateUser(patch) {
  const data = {
    ...patch,
  };

  const updatedUser = await request(`/user`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });

  return updatedUser;
}

export function getUser() {
  const token = getToken();
  if (!token) {
    globalState.user = {
      id: '',
      name: '',
      email: '',
      avatar: '',
      email_verified: true,
      token: '',
    };
    return null;
  }

  try {
    const decoded = jwtDecode(token);
    globalState.user = {
      ...globalState.user,
      id: decoded.id,
      name: decoded.name,
      email: decoded.email,
      token: token,
      ...globalState.userInfo,
    };
    return globalState.user;
  } catch (e) {
    console.error(e);
    globalState.user = {
      id: '',
      name: '',
      email: '',
      avatar: '',
      token: '',
      email_verified: true,
    };
    return null;
  }
}
